import { createSelector } from 'reselect';
import { getAdvertiser } from '../reducer';

const getAvatarUrl = createSelector(
  [getAdvertiser],
  advertiser => advertiser.avatarURL,
);

export { getAvatarUrl };
